import React from 'react';
import styled from 'styled-components';
import { ink, sky } from '../theme';

const Wrap = styled.div`
  /* на всю ширину колонки: компенсация padding Container 20px */
  width: calc(100% + 40px);
  max-width: none;
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: 2.75rem;
  position: relative;

  @media (max-width: 768px) {
    margin-bottom: 2.25rem;
  }

  @media (max-width: 480px) {
    margin-bottom: 2rem;
  }
`;

const Panel = styled.div`
  position: relative;
  padding: ${props => (props.$wide ? '0.95rem 1.25rem 1rem' : '1.05rem 1.5rem 1.1rem')};
  padding-left: calc(0.75rem + 5px);
  background: linear-gradient(168deg, #0e3a63 0%, ${ink} 48%, #021427 100%);
  border: 1px solid rgba(142, 207, 255, 0.28);
  border-radius: 0;
  box-shadow:
    0 6px 28px rgba(3, 26, 56, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.07);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 1px;
    pointer-events: none;
  }
`;

const GridBg = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0.14;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.45) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.45) 1px, transparent 1px);
  background-size: 14px 14px;
  pointer-events: none;
  filter: blur(0.25px);
`;

const Glow = styled.div`
  position: absolute;
  top: -40%;
  right: -10%;
  width: 55%;
  height: 140%;
  background: radial-gradient(ellipse at center, rgba(142, 207, 255, 0.12) 0%, transparent 65%);
  pointer-events: none;
`;

const AccentBar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background: linear-gradient(180deg, ${sky} 0%, #4a8fb8 55%, rgba(142, 207, 255, 0.35) 100%);
  box-shadow: 3px 0 14px rgba(142, 207, 255, 0.2);
  pointer-events: none;
`;

const Title = styled.h2`
  position: relative;
  z-index: 1;
  margin: 0;
  padding-left: 0.65rem;
  color: #f8fbff;
  font-size: ${props =>
    props.$wide ? 'clamp(0.68rem, 1.45vw, 0.88rem)' : 'clamp(0.78rem, 1.85vw, 1rem)'};
  font-weight: 800;
  letter-spacing: ${props => (props.$wide ? '0.07em' : '0.2em')};
  text-transform: uppercase;
  text-align: center;
  line-height: 1.45;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
`;

/**
 * Заголовок секции в стиле чертежа: тёмно-синяя плашка, сетка, акцент слева.
 */
const BlueprintSectionTitle = ({ children, className, $wide }) => (
  <Wrap className={className}>
    <Panel $wide={$wide}>
      <GridBg aria-hidden />
      <Glow aria-hidden />
      <AccentBar aria-hidden />
      <Title $wide={$wide}>{children}</Title>
    </Panel>
  </Wrap>
);

export default BlueprintSectionTitle;
